import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "close" }

import { ref, onMounted } from "vue";
import usePopupImg from "@/composables/usePopupImg";
import { NSpin } from "naive-ui";

export default /*#__PURE__*/_defineComponent({
  props: ["articleID", "parentID"],
  setup(__props) {

const props = __props



let { imgName, title, show, pos, className, type, showSpin } = usePopupImg();

// onMounted(() => {
//   if (props.articleID) {
//     fetchContent()
//   }
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_unref(NSpin), {
      size: "large",
      id: "spin-popup-img"
    }, null, 512), [
      [_vShow, _unref(showSpin)]
    ]),
    _withDirectives(_createElementVNode("div", {
      id: "layout-popup-img",
      style: _normalizeStyle({ top: _unref(pos).y + 'px', left: _unref(pos).x + 'px' })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgName).data, (name, index) => {
        return (_openBlock(), _createElementBlock("img", {
          src: name,
          alt: _unref(title),
          id: "popup-img",
          key: index,
          class: _normalizeClass(_unref(className).data)
        }, null, 10, _hoisted_1))
      }), 128)),
      _withDirectives(_createElementVNode("div", _hoisted_2, "关闭", 512), [
        [_vShow, _unref(show) && _unref(type) == 1]
      ])
    ], 4), [
      [_vShow, _unref(show)]
    ])
  ], 64))
}
}

})